export const ROLES = {
  USER: 'user',
  OWNER: 'owner',
  ADMIN: 'admin',
};

export const SPORTS = {
  FUTBOL: 'Futbol',
  PADEL: 'Padel',
};

export const TEAM = {
  LOCAL: 0,
  VISIT: 1,
};
export const SPORTS_ICONS = {
  FUTBOL: '⚽',
  PADEL: '🥎',
};

export const STATE = {
  OLD: 'old',
  IN: 'in',
  NEW: 'new',
};

export const VIEW = {
  LIST: 'list',
  GRID: 'grid',
};

export const LEVELS = {
  BASIC: 'Basico',
  MEDIUM: 'Medio',
  ADVANCE: 'Avanzado',
};

export const POSITION = {
  ANY: 'Todas',
  GOALKEEPER: 'Portero',
  DEFENCE: 'Defensa',
  MIDFIELD: 'Mediocampo',
  FOWARD: 'Delantero',
};
export const LANGUAGES = {
  SPANISH: 'es',
  ENGLISH: 'en',
  ARABIC: 'ar',
};
